module.exports = __webpack_public_path__ + "static/media/favicon.d59ed23a.ico";